import "./AdminLogin.scss";
import Login from "../../components/Login/Login";
import { withRouter } from "react-router-dom";

const AdminLogin = (props) => {
  return (
    <div className="admin-login">
      <Login {...props} />
    </div>
  );
};

export default withRouter(AdminLogin);
